import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { getQuestionTypes } from "../../selectors";
import { Typography, Tooltip, InputAdornment, IconButton, TextField, Grid, Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon, CloseIcon, DoneIcon } from "@icarius-icons";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import { FileCopyIcon } from "@icarius-icons/index";
import { GalleryDialog } from "@icarius-common/galleryDialog";
import GalleryButtonAndDisplay from "@icarius-common/galleryDialog/components/galleryButtonAndDisplay";

const gridStyle = { height: 75, padding: "0px 10px" };

const PollQuestion = (props) => {

  const {
    index,
    inUse,
    data,
    hideDuplicate,
    deleteQuestion,
    duplicateQuestion,
    modifyQuestion,
    isONAPoll,
  } = props;

  const [imagesDialogIsOpen, setImagesDialogIsOpen] = useState(false);

  const questionTypes = useSelector(getQuestionTypes);
  const newOptionRef = useRef("");

  const isQuestionWithOptions = data.type === "O" || data.type === "L";
  
  const handleOptionChange = (text = '', optionIndex, isNewOption) => {
    //si el text viene de la ref del input de la nueva opcion, limpiarlo
    if (isNewOption) {
      newOptionRef.current.value = "";
    }

    const newOptionsArray = [...data.options];
    newOptionsArray.splice(optionIndex, 1, text);

    modifyQuestion(index, newOptionsArray, 'options');
  }

  const handleOptionDelete = (optionIndex) => {
    const newOptionsArray = [...data.options];
    newOptionsArray.splice(optionIndex, 1);

    modifyQuestion(index, newOptionsArray, 'options');
  }

  const handleSelectImage = (image) => {
    modifyQuestion(index, image, "image");
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <DialogTitleDivider />
      </div>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
        <Grid container item xs={inUse ? 12 : 11}>
          <Grid container item alignItems="center" sm={12} md={9} style={gridStyle}>
            <TextField
              disabled={inUse}
              required
              fullWidth
              margin={"none"}
              label={`${getLocalizedString("pollQuestion")} ${index + 1}`}
              value={data.question}
              onChange={(e) => modifyQuestion(index, e.target.value, 'question')}
              inputProps={{ maxLength: 254 }}
            />
          </Grid>
          <Grid container item alignItems="center" sm={12} md={3} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-question-${index + 1}`}>{getLocalizedString("type")}</InputLabel>
              <Select
                disabled={inUse}
                value={data.type}
                labelId={`label-question-${index + 1}`}
                id={`select-question-${index + 1}`}
                onChange={(e) => modifyQuestion(index, e.target.value, 'type')}
                margin={"none"}
              >
                {
                  questionTypes.filter(item => (isONAPoll && item.key === 'O') || !isONAPoll).map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {
          !inUse &&
          <Grid container item xs={1} alignItems="center" justify="space-evenly">
            {
              !hideDuplicate &&
              <Tooltip title={getLocalizedString("duplicate")}>
                <IconButton size={"small"} disableRipple onClick={() => duplicateQuestion(index)}>
                  <FileCopyIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            <Tooltip title={getLocalizedString("delete")}>
              <IconButton size={"small"} disableRipple onClick={() => deleteQuestion(index)}>
                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        }
        <Grid container item alignItems="center" justify="flex-end" sm={12} style={{ padding: "0px 10px" }}> {/* opciones */}
          {
            isQuestionWithOptions &&
            <Grid container item xs={12} justify="flex-end" style={{ padding: "5px 0px" }}>
              <Grid container item xs={12} md={6}>
                <Typography className={data?.options.length > (isONAPoll ? 2 : 1) ? "whiteText" : "errorColor"} variant="caption">
                  {isONAPoll ? getLocalizedString("questionAtLeastThreeOption") : getLocalizedString("questionAtLeastTwoOptions")}
                </Typography>
              </Grid>
            </Grid>
          }
          {
            isQuestionWithOptions && data.options.map((option, optionIndex) => {
              return (
                <Grid container item xs={12} justify="flex-end" key={optionIndex} style={{ padding: "5px 0px" }}>
                  <Grid container item xs={12} md={6}>
                    <TextField
                      disabled={inUse}
                      required
                      fullWidth
                      margin={"none"}
                      label={`${getLocalizedString("pollOption")} ${optionIndex + 1}`}
                      value={option}
                      onChange={(e) => handleOptionChange(e.target.value, optionIndex)}
                      inputProps={{ maxLength: 20 }}
                      InputProps={{
                        endAdornment:
                          inUse ?
                            null
                            : (
                              <InputAdornment style={{ cursor: "pointer" }}>
                                <Tooltip title={getLocalizedString("deletePollOption")}>
                                  <IconButton onClick={() => handleOptionDelete(optionIndex)}>
                                    <CloseIcon className="whiteText" fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </InputAdornment>
                            ),
                      }}
                    />
                  </Grid>
                </Grid>
              )
            }
            )
          }
          {
            isQuestionWithOptions && !inUse &&
            <Grid container item xs={12} justify="flex-end" style={{ padding: "5px 0px" }}>
              <Grid container item xs={12} md={6} justify="center" alignItems="center">
                <TextField
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("pollAddOption")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleOptionChange(e.target.value, data.options.length, true);
                    }
                  }}
                  name={"newOption"}
                  inputProps={{ maxLength: 20 }}
                  inputRef={newOptionRef}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment style={{ cursor: "pointer" }}>
                        <Tooltip title={getLocalizedString("pollAddOption")}>
                          <IconButton onClick={() => handleOptionChange(newOptionRef.current.value, data.options.length, true)}>
                            <DoneIcon className="whiteText" fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          }
        </Grid>
        <Grid container item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
          <GalleryButtonAndDisplay
            disabled={data?.inUse}
            image={data.image}
            handleOpenGallery={() => setImagesDialogIsOpen(true)}
          />
        </Grid>
      </Grid>
      {
        imagesDialogIsOpen &&
        <GalleryDialog
          open={imagesDialogIsOpen}
          initialValue={data.image}
          type={"news"}
          handleSubmit={(image) => handleSelectImage(image)}
          handleClose={() => setImagesDialogIsOpen(false)}
        />
      }
    </>
  );
}

export default PollQuestion;
